import React, { useMemo } from 'react';
import StyledBox from 'views/tours-module/TourReviewsView/components/ReviewsSections/ReviewsSections.styles';
import ERPagination from 'views/common/components/UI/ERPagination';
import { Box } from '@mui/material';
import { ReviewsWrapper } from 'views/common/components';
import { API } from 'lib/config/axios';

const ReviewsSections = (props) => {
  const {
    reviews,
    handlePaginationClick,
    getTourReviewsData,
    addNewReview,
    tourName,
    tourId,
  } = props;
  const pagingData = useMemo(
    () => ({
      active_page: reviews.pagination?.page,
      pages_count: reviews.pagination?.pages_count,
    }),
    [reviews],
  );

  return (
    <StyledBox>
      <ReviewsWrapper
        reviewsData={reviews}
        reviewAPI={API.tours.review.replace('{tour_id}', tourId)}
        voteAPI={API.tours.reviewVote}
        getPageData={getTourReviewsData}
        setReviews={addNewReview}
        ratingLable={tourName}
        fullReviews
      />
      {(reviews.reviews.length > 2 || pagingData.pages_count > 1) && (
        <Box className="RSPaggingContiner">
          <ERPagination
            data={pagingData}
            handleChange={handlePaginationClick}
          />
        </Box>
      )}
    </StyledBox>
  );
};

export { ReviewsSections };
